import produce from "immer"

import {
    SET_LOCALE3,
    LOAD_LOCALE3_SUCCESS
} from "../constants";

const initialState = {
    locale: '',
    localeData : {}
};

const locale3Reducer = produce((draft, action) => {

    switch (action.type) {
      case LOAD_LOCALE3_SUCCESS:
            draft.locale = action.localeData.name;
            draft.localeData = action.localeData;
            break;
      case SET_LOCALE3:
            draft.locale = action.locale;
            break;
      default:
            break;
    }
},initialState);

export default locale3Reducer;

/* Getters */

export const getLocale3 = state => {
    return state.locale;
};
  
export const getLocale3Data = state => {
    return state.localeData;
};